module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"DeleteSuccess":"Le point de cueillette a bien été supprimé"}}')
  delete Component.options._Ctor
}
